import React, { useContext } from "react";
import { IMAGES } from "../assets";
import { AuthContext } from "../context";
import { FILE_URL } from "../constants/Constants";
import PropTypes from "prop-types";

const ReviewCard = ({ date, name, profile, comment, ratings }) => {
  ReviewCard.propTypes = {
    date: PropTypes.any,
    name: PropTypes.string,
    profile: PropTypes.any,
    comment: PropTypes.string,
    ratings: PropTypes.any,
  };
  const { activeLanguage } = useContext(AuthContext);
  const marathiDigitsMap = {
    0: "०",
    1: "१",
    2: "२",
    3: "३",
    4: "४",
    5: "५",
    6: "६",
    7: "७",
    8: "८",
    9: "९",
  };

  const datesplit = date.split("").map((char) => {
    if (!isNaN(char)) {
      return marathiDigitsMap[char];
    } else {
      return char;
    }
  });
  return (
    <div className="review-card p-2 rounded-2xl border mt-2 shadow-md mx-2">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-full bg-slate-400">
          <img
            src={profile ? `${FILE_URL}${profile}` : ""}
            className="w-full h-full object-cover"
            alt="Profile"
          />
        </div>
        <h2 className="text-lg font-medium">{name} </h2>
      </div>
      <div className="flex items-center justify- gap-2">
        <div className="flex gap-1">
          {[1, 2, 3, 4, 5].map((index) => (
            <img
              key={index}
              className="w-auto h-4 cursor-pointer"
              src={index <= ratings ? IMAGES?.starIcon : IMAGES?.starOrangeIcon}
              alt="Star"
            />
          ))}
        </div>
        <p className="text-sm">
          {activeLanguage === "Marathi" ? datesplit.join("") : date}
        </p>
      </div>
      <p className="mt-2 text-sm font-base text-[#8A8A8A]">{comment}</p>
    </div>
  );
};

export default ReviewCard;
